import { ProductDetailsResponse, ProductRole } from '@/@types/Products';
import CustomSheet from '@/components/shared/Sheet/Sheet';
import useModalStore from '@/store/useModalStore';
import { useOutletContext, useParams } from 'react-router-dom';
import PartnersList from './Partials/PartnersList';
import SidePartnerConfig from '../Affiliate/Partials/SidePartnerConfig';
export default function Partners() {
  const { id } = useParams<{ id: string }>();
  const { modals, closeModal } = useModalStore();
  const { product } = useOutletContext<{ product: ProductDetailsResponse }>();
  const isProducer = product?.relationship?.role === ProductRole.PRODUCER;

  if (!id || !isProducer) {
    return null;
  }

  return (
    <>
      <PartnersList productId={id} />

      <CustomSheet
        open={modals['config-partner-program']}
        onClose={() => closeModal('config-partner-program')}
      >
        <SidePartnerConfig
          productId={id}
          onClose={() => closeModal('config-partner-program')}
        />
      </CustomSheet>

    </>
  );
}
